import styled from 'styled-components';
import { getCombinedClassNames } from 'utils/style';
import Icon from 'components/Core/Icon';
import { ACTION_TYPE_SECONDARY } from 'constants/Action';

const baseClassNames = [
  'flex',
  'flex-row',
  'items-center',
  'justify-center',
  'text-center',
  'text-base',
  'md:text-lg',
  'font-semibold',
  'border-solid',
  'border-3',
  'border-primary',
  'rounded-100',
  'p-2',
  'duration-200',
  'ease-in-out',
  'cursor-pointer',
  'transition',
  'max-w-full',
  'md:py-3',
  'md:px-8',
  'active:border-primary-600',
  'active:shadow-none',
  'focus:outline-none',
  'visited:text-opacity-60',
];

const ButtonPrimary = getCombinedClassNames([
  ...baseClassNames,
  'bg-primary',
  'text-basic-200',
  'hover:shadow-primary',
  'focus:shadow-primary',
  'active:bg-primary-600',
]);

const ButtonSecondary = getCombinedClassNames([
  ...baseClassNames,
  'text-primary',
  'bg-white',
  'hover:shadow-secondary',
  'focus:shadow-secondary',
  'active:border-primary-600',
  'active:text-primary-600',
]);

const Button = styled.button.attrs((props) => {
  if (props.styleType === ACTION_TYPE_SECONDARY)
    return {
      type: props.type ? props.type : 'button',
      className: ButtonSecondary,
    };
  return {
    type: props.type ? props.type : 'button',
    className: ButtonPrimary,
  };
})`
  content: '${(props) => props.styleType}';
`;

const Link = styled.a.attrs((props) => {
  if (props.styleType === ACTION_TYPE_SECONDARY)
    return {
      className: ButtonSecondary,
    };
  return {
    className: ButtonPrimary,
  };
})`
  display: inline-flex;
  text-decoration: none;
`;

const IconElem = styled(Icon).attrs(() => {
  const classNamesToAdd = ['w-2', 'h-3', 'ml-2'];
  return {
    extraClassNames: getCombinedClassNames(classNamesToAdd),
  };
})``;

export { Button, IconElem, Link };
